import type { ReactNode } from "react";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import type { DropdownOptions } from "@circle-react-shared/uikit/Dropdown";
import { Dropdown } from "@circle-react-shared/uikit/Dropdown";

export interface AddPropertyDropdownProps {
  children?: ReactNode;
  dataTestId?: string;
  label?: string;
  options?: DropdownOptions;
}

export const AddPropertyDropdown = ({
  label = t("builder_ui.editor.add_property"),
  options,
  dataTestId,
  children,
}: AddPropertyDropdownProps) => (
  <Dropdown
    direction="bottom-end"
    menuWrapperClassName="!mt-2"
    buttonClassName="flex items-center flex justify-center !rounded-full transition-colors duration-200 hover:bg-tertiary focus-visible:outline-secondary focus-visible:rounded-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:bg-tertiary"
    menuItemsClassName="overflow-y-auto"
    button={
      <TippyV2 content={label} className="flex items-center p-1">
        <Icon
          className="text-default !size-4"
          type="plus-v2"
          size={16}
          aria-label={label}
        />
      </TippyV2>
    }
    options={options}
    dataTestId={dataTestId}
  >
    {children}
  </Dropdown>
);
